import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { PopUp } from "../../components/PopUp/PopUp.js";

const initialSort = [
  {
    field: "row",
    dir: "asc",
  },
];

const initialDataState = {
  skip: 0,
  take: 6,
};

const voidRecord = [];

function FeedRequestGridContainer({ show, setShow }) {
  const dataGrid = useSelector((state) => state.feed);
  const [values, setValues] = useState(voidRecord);
  const [sort, setSort] = useState(initialSort);
  const [page, setPage] = useState(initialDataState);

  useEffect(() => {
    if (dataGrid !== undefined) {
      setValues(dataGrid);
    }
  }, [dataGrid]);

  const hideModal = () => {
    setShow(false);
  };

  const pageChange = (event) => {
    setPage(event.page);
  };

  return (
    <>
      <PopUp show={show.status} handleClose={hideModal}>
        <div
          className="row"
          style={{
            height: "30px",
            marginLeft: "0px",
            marginRight: "0px",
            backgroundColor: "#FDA443",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          {" "}
        </div>
        <p></p>
        <h2 className="row justify-content-md-center">{show.message}</h2>
      </PopUp>
      <Grid
        style={{
          height: "300px",
        }}
        //data={dataGrid}
        //data={values}
        data={orderBy(values, sort)}
        skip={page.skip}
        take={page.take}
        total={0}
        pageable={false}
        pageSize={25}
        onPageChange={pageChange}
        resizable={true}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <Column
          field="row"
          title="N° Riga"
          width="auto"
          cell={(props) => {
            const field = "row";
            const rowValid = props.dataItem["errorCode"] !== 0;
            const style = {
              backgroundColor: rowValid ? "rgb(243, 23, 0, 0.32)" : "",
            };

            return <td style={style}>{props.dataItem[field]}</td>;
          }}
        />
        <Column
          field="message"
          title="Status Message"
          width="auto"
          cell={(props) => {
            const field = "message";
            const rowValid = props.dataItem["errorCode"] !== 0;
            const style = {
              backgroundColor: rowValid ? "rgb(243, 23, 0, 0.32)" : "",
            };

            return <td style={style}>{props.dataItem[field]}</td>;
          }}
        />
      </Grid>
    </>
  );
}

export const FeedRequestGrid = connect(null, null)(FeedRequestGridContainer);
